import frame from '@/frame/frame'

// import login from './teacher/login.js'
import user from './teacher/user.js'
// import msg from './teacher/msg.js'
// import course from './teacher/course.js'
// import group from './teacher/group.js'
// import courseware from './teacher/courseware.js'
// import afterClass from './teacher/afterClass.js'
// import report from './teacher/report.js'
export default [
    // {path:'login', component:frame, children: login },
    {path:'user', component:frame, children: user },
    // {path:'msg', component:frame, children: msg },
    // {path:'course', component:frame, children: course },
    // {path:'group', component:frame, children: group },
    // {path:'courseware', component:frame, children: courseware },
    // {path:'afterClass', component:frame, children: afterClass },
    // {path:'report', component:frame, children: report },
]



// WEBPACK FOOTER //
// ./src/router/teacher.js